import { render, staticRenderFns } from "./donor-settings.vue?vue&type=template&id=01259a36&scoped=true&"
import script from "./donor-settings.vue?vue&type=script&lang=js&"
export * from "./donor-settings.vue?vue&type=script&lang=js&"
import style0 from "./donor-settings.vue?vue&type=style&index=0&id=01259a36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01259a36",
  null
  
)

export default component.exports